import backpack from "./backpack.svg";
import computerScience from "./computer_science.svg";
import homework from "./homework.svg";
import languageArts from "./language_arts.svg";
import math from "./math.svg";
import science from "./science.svg";
import trophy from "./trophy.svg";

/** Bundled SVG metadata used as Matter.js sprite textures. */
export type StickerImage = Readonly<{
	src: string;
	width: number;
	height: number;
}>;

const stickers: StickerImage[] = [
	backpack,
	computerScience,
	homework,
	languageArts,
	math,
	science,
	trophy,
];

export default stickers;
